import { makeSx } from '../../theme/_utils'
import { defaultPalette } from '../../theme/idsTheme'

export default makeSx({
    paper: {
        textAlign: 'center',
        color: defaultPalette.secondary.main,
        borderRadius: '2px',
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2.5rem',
        padding: 0,
    },
    media: {
        height: 140,
        backgroundSize: 'contain',
    },
    cardContentText: {
        color: defaultPalette.typography.half,
    },
    buttonContainer: {
        width: '100%',
        maxWidth: '375px',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
    },
})
